<template>
  <div id="app">
    <!-- <router-view /> -->

    <HcoListView />
  </div>
</template>

<script>
import HcoListView from "@/views/HcoList";

export default {
  name: "App",
  components: {
    HcoListView
  }
};
</script>

<style lang="scss"></style>
